import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';
import {
  LucideAngularModule,
  Sparkles,
  Check,
  Heart,
  Mail,
  LogOut,
} from 'lucide-angular';
import { AuthService, UserProfile } from '../../common/auth/auth.service';
import { ConfettiCanvasComponent } from '../../common/components/confetti-canvas/confetti-canvas';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, RouterLink, ConfettiCanvasComponent],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly destroyRef = inject(DestroyRef);

  private readonly userProfile$$ = new BehaviorSubject<UserProfile | null>(null);
  protected readonly userProfile$ = this.userProfile$$.asObservable();

  protected readonly icons = {
    Sparkles,
    Check,
    Heart,
    Mail,
    LogOut,
  };

  ngOnInit(): void {
    this.loadUserProfile();
  }

  protected logout(): void {
    this.authService.logout()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.router.navigate(['/wizard/v2/landing']);
      });
  }

  private loadUserProfile(): void {
    this.authService.getProfile()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (profile) => this.userProfile$$.next(profile),
        error: (err) => console.error('Failed to load user profile:', err),
      });
  }
}

